module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_3009.a59098ce.png";